import React from 'react';
import LoadingSpinner from 'components/generic/LoadingSpinner';
import appColors from '../../../../common/app_colors';

const WholeMeLoadingCircle = () => (
  <LoadingSpinner
    size="50vw"
    sx={{
      color: appColors.wholeMeAssets.primary,
      rotate: '-90deg',
      maxWidth: 350,
      maxHeight: 350,
    }}
    thickness={5}
  />
);

export default WholeMeLoadingCircle;
